import * as React from 'react';
import { Link } from 'gatsby';
import { memo } from 'react';
import Logo from '../../icons/SellUsYourJewelry';

const ShopMenu = memo(({ dropdown, setDropdown }) => {
  return (
    <>
      <div className={'mx-auto w-auto p-2 text-center shadow-md lg:mb-4'}>
        <Link to={'/'}>
          <Logo className={'mx-auto w-[236px]'} />
        </Link>
      </div>
      <div className={'bg-white md:border-b md:border-gray-400 md:p-2 md:pb-4'}>
        <nav
          role="navigation"
          className={
            (dropdown ? 'flex' : 'hidden') +
            ' absolute top-16 left-0 z-20 w-full flex-col bg-black p-6 text-gray-700 shadow-md md:relative md:top-0 md:flex md:w-auto md:flex-row md:justify-center md:space-x-6 md:bg-transparent md:p-0 md:shadow-none'
          }
          itemScope
          itemType="https://schema.org/SiteNavigationElement"
        >
          <Link
            to={'/fine-watches/'}
            className={'uppercase text-white hover:underline md:text-gray-600'}
          >
            Fine Luxury Watches
          </Link>
          <Link
            to={'/jewelry/'}
            className={'uppercase text-white hover:underline md:text-gray-600'}
          >
            Luxury Jewelry
          </Link>
          <Link
            to={'/gia-diamonds/'}
            className={'uppercase text-white hover:underline md:text-gray-600'}
          >
            Certified Diamonds
          </Link>
          <Link
            to={'/what-s-new/'}
            className={'uppercase text-white hover:underline md:text-gray-600'}
          >
            New Arrivals
          </Link>
          <a
            href={'https://www.grayandsons.com/repairs'}
            target={'_blank'}
            className={'uppercase text-white hover:underline md:text-gray-600'}
          >
            Repairs
          </a>
        </nav>
        {dropdown ? (
          <button
            className={'absolute top-0 left-0 z-10 h-full w-full bg-black opacity-30 md:hidden'}
            onClick={() => {
              setDropdown(false);
            }}
          >
            <span className={'sr-only'}>Close menu</span>
          </button>
        ) : (
          ''
        )}
      </div>
    </>
  );
});

export default ShopMenu;
